export var scrollTrackIntoView = function scrollTrackIntoView(trackId) {
  var _document$querySelect;
  if (!trackId || !document) return;
  var trackElement = (_document$querySelect = document.querySelector("[data-trackid=\"".concat(trackId, "\"]"))) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.closest('article');
  if (trackElement) {
    trackElement.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest'
    });
  }
};